export const REQUEST_CREDIT_REVIEW_LEVELS = 'REQUEST_CREDIT_REVIEW_LEVELS';
export const REQUEST_CREDIT_REVIEW_LEVELS_SUCCESS = 'REQUEST_CREDIT_REVIEW_LEVELS_SUCCESS';
export const REQUEST_CREDIT_REVIEW_LEVELS_ERROR = 'REQUEST_CREDIT_REVIEW_LEVELS_ERROR';

export enum CreditReviewLevelsActionTypes {
  Request = 'REQUEST_CREDIT_REVIEW_LEVELS',
  RequestSuccess = 'REQUEST_CREDIT_REVIEW_LEVELS_SUCCESS',
  RequestError = 'REQUEST_CREDIT_REVIEW_LEVELS_ERROR',
}

export interface RequestCreditRequestLevelsAction {
  type: CreditReviewLevelsActionTypes.Request;
}

export interface RequestCreditRequestLevelsSuccessAction {
  type: CreditReviewLevelsActionTypes.RequestSuccess;
  payload: any;
}

export interface RequestCreditRequestLevelsErrorAction {
  type: CreditReviewLevelsActionTypes.RequestError;
  payload: string;
}

export const requestCreditRequestLevelsAction = (): RequestCreditRequestLevelsAction => {
  return {
    type: CreditReviewLevelsActionTypes.Request,
  };
};

export const requestCreditRequestLevelsSuccessAction = (
  payload: any,
): RequestCreditRequestLevelsSuccessAction => {
  return {
    type: CreditReviewLevelsActionTypes.RequestSuccess,
    payload,
  };
};

export const requestCreditRequestLevelsErrorAction = (
  error: string,
): RequestCreditRequestLevelsErrorAction => {
  return {
    type: CreditReviewLevelsActionTypes.RequestError,
    payload: error,
  };
};

export type Actions =
  | RequestCreditRequestLevelsAction
  | RequestCreditRequestLevelsSuccessAction
  | RequestCreditRequestLevelsErrorAction;
